function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { Record } from 'immutable';
import { Auth } from 'aws-amplify';

function getApiRequestHeaders() {
  return _getApiRequestHeaders.apply(this, arguments);
}

function _getApiRequestHeaders() {
  _getApiRequestHeaders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var session;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Auth.currentSession();

          case 2:
            session = _context.sent;
            return _context.abrupt("return", {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              cookies: session.accessToken.jwtToken
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _getApiRequestHeaders.apply(this, arguments);
}

export default Record([{
  session: getApiRequestHeaders()
}]);